/**
 * MaintenancePage Component
 * 
 * Displayed when the application is in maintenance mode.
 * Shows a friendly message to users and provides a way to refresh.
 */
export function MaintenancePage() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="mb-6">
          <div className="w-24 h-24 mx-auto bg-yellow-100 rounded-full flex items-center justify-center">
            <svg
              className="w-12 h-12 text-yellow-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="font-display text-3xl font-bold text-slate-900 mb-4">
          Maintenance en cours
        </h1>

        {/* Message */}
        <p className="text-slate-600 mb-8 leading-relaxed">
          Spellion est actuellement en maintenance pour améliorer votre expérience.
          <br />
          Nous serons de retour très bientôt !
        </p>

        {/* Refresh button */}
        <button
          type="button"
          onClick={handleRefresh}
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-xl font-medium hover:bg-primary-700 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span>Vérifier à nouveau</span>
        </button>

        {/* Admin link */}
        <p className="mt-8 text-sm text-slate-500">
          Administrateur ?{' '}
          <a href="/admin" className="text-primary-600 hover:text-primary-700 underline">
            Accéder à l'administration
          </a>
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
